export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';
export const SET_TABLE_PAGE = 'SET_TABLE_PAGE';
export const SET_TABLE_PAGE_SIZE = 'SET_TABLE_PAGE_SIZE';
export const SET_TABLE_SORTED = 'SET_TABLE_SORTED';
export const SET_TABLE_FILTERS = 'SET_TABLE_FILTERS';
